<template>
  <div class="card card-shadow">
    <div class="card-header d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center">
      <h1 class="h4">{{ translate('tables.coupons.title') }}</h1>
      <div class="btn-toolbar mb-2 mb-md-0">
        <button class="btn btn-sm btn-primary" @click="showCreateCouponModal">
          {{ translate('tables.coupons.create') }}
          <span class="fa fa-plus"></span>
        </button>
      </div>
    </div>
    <div class="card-body p-0">
      <table class="table card-table table-hover mb-0">
        <thead class="thead-light">
        <tr>
          <th>{{ translate('tables.coupons.columns.id') }}</th>
          <th>{{ translate('tables.coupons.columns.name') }}</th>
          <th>{{ translate('tables.coupons.columns.code') }}</th>
          <th>{{ translate('tables.coupons.columns.discount') }}</th>
          <th>{{ translate('tables.coupons.columns.limit_count') }}</th>
          <th>{{ translate('tables.coupons.columns.used_times') }}</th>
          <th>{{ translate('tables.coupons.columns.ends_at') }}</th>
          <th>{{ translate('tables.coupons.columns.active') }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="eachCoupon in coupons"
            :class="coupon && (coupon.id === eachCoupon.id) ? 'table-info' : ''"
            @click="showCoupon(eachCoupon.id)">
          <td>{{ eachCoupon.id }}</td>
          <td>{{ eachCoupon.name }}</td>
          <td>{{ eachCoupon.code }}</td>
          <td>{{ eachCoupon | discount }}</td>
          <td>{{ eachCoupon.limit_count }}</td>
          <td>{{ eachCoupon.payments_count }}</td>
          <td>{{ eachCoupon.ends_at | formatDate }}</td>
          <td v-if="eachCoupon.active" class="text-success">{{ translate('tables.coupons.active.yes') }}</td>
          <td v-else class="text-danger">{{ translate('tables.coupons.active.no') }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: ['coupons', 'coupon'],

  data () {
    return {};
  },

  mounted () {
    this.$parent.$emit('getCoupons');
  },

  methods: {
    showCoupon (couponId) {
      this.$parent.$emit('getCoupon', couponId);
    },

    showCreateCouponModal () {
      this.$parent.$emit('showCreateCouponModal');
    },
  },

  filters: {
    formatDate: function (value) {
      if (value) {
        return moment(String(value)).format('YYYY-MM-DD');
      }
    },

    discount: function (coupon) {
      if (coupon.type === 'percentage') {
        return coupon.percentage + ' %';
      }
      if (coupon.type === 'amount') {
        return coupon.amount + ' €';
      }
    },
  }
};
</script>
